import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useDateFormatter } from '@/hooks/useDateFormatter'
import { useUI } from '@/hooks/useUI'
import { Languages } from 'lucide-react'

export function DropDownTranslator() {
  const { language, setLanguage } = useUI()
  const { formatDateTime } = useDateFormatter()

  return (
    <div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2 text-muted-foreground text-[12px]">
            <Languages className="size-3" />
            <span>{language.toUpperCase()}</span>
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" className="text-muted-foreground">
          <DropdownMenuItem onClick={() => setLanguage('th')} className={language === 'th' ? 'bg-accent' : ''}>
            <span className="text-[12px]">TH ภาษาไทย</span>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setLanguage('en')} className={language === 'en' ? 'bg-accent' : ''}>
            <span className="text-[12px]">EN English</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <span className="hidden w-[160px] shrink-0 text-right text-xs text-muted-foreground md:block">
        {formatDateTime(new Date(), {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </span>
    </div>
  )
}
